import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { startLenis } from "@/lib/lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import MarqueeStrip from "@/components/landing/MarqueeStrip";
import Manifesto from "@/components/landing/Manifesto";
import InsightGlow from "@/components/landing/InsightGlow";
import TrialCta from "@/components/landing/TrialCta";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";
import AdminPage from "@/components/landing/AdminPage";

function LandingPage() {
  return (
    <div data-testid="rosteno-app" className="bg-[#0A0E17] text-white min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <InsightGlow />
        <TrialCta />
        <Testimonials />
        <Faq />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const stop = startLenis();
    return stop;
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster theme="dark" position="bottom-center" />
    </BrowserRouter>
  );
}
